export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI!;
export const REDIRECT_URI_USER = process.env.REACT_APP_REDIRECT_URI_USER!;
export const CLIENT_ID_GOOGLE = process.env.REACT_APP_CLIENT_ID!;
export const CLIENT_SECRET_GOOGLE = process.env.REACT_APP_CLIENT_SECRET!;
export const CLIENT_ID_MS = process.env.REACT_APP_CLIENT_ID_MS!;
export const TENANT_MS = process.env.REACT_APP_TENANT_ID_MS!;
export const CLIENT_ID_APPLE = process.env.REACT_APP_CLIENT_ID_APPLE!;
export const KEY_GOOGLE_MAP = process.env.REACT_APP_KEY_GOOGLE_MAP!;
export const MAP_ID = process.env.REACT_APP_MAP_ID!;
